import {Rule} from 'antd/lib/form'

export const FIELD_RULES: Rule[] = [{required: true}]

export const EMAIL_FIELD_RULES: Rule[] = [{...FIELD_RULES[0], type: 'email'}]

export const PASSWORD_FIELD_RULES: Rule[] = [
  ...FIELD_RULES,
  {
    validator(_: any, value: string) {
      if (/(?=.*[A-Z])(?=.*[0-9])(?=.{8,})/.test(value)) {
        return Promise.resolve()
      }
      return Promise.reject()
    },
  },
]
